import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { useVaccinationForVerification } from '@modmd/data'
import { useSearchState } from 'internal-portal/utils/useSearchState'
import DashboardPage from 'internal-portal/sharedComponents/DashboardPage'
import Datalist from 'components/Datalist'
import Card from 'components/Card'
import { Box, Container } from 'components/Layout'
import TextInput from 'components/TextInput'
import Icon from 'components/Icon'
import { DEVICE } from 'theme'
import { useIsMinDevice } from 'utils/hooks/useMedia'
import { VaccineRecordVerificationDatalist } from 'sharedComponents/VaccineRecordVerificationDatalist'

export const USERS_PAGE_LENGTH = 10

const VaccineRecordVerification: React.VFC<RouteComponentProps> = () => {
  const searchState = useSearchState<{
    emailOrNameLike?: string
    page?: string
    type?: string
  }>()
  const isMobile = useIsMinDevice(DEVICE.TABLET)

  const {
    data: vaccinationForVerification,
    loading: isVaccinationLoading,
  } = useVaccinationForVerification({
    filter: Object.entries({
      emailOrNameLike: searchState.data.emailOrNameLike ? searchState.data.emailOrNameLike : null,
    }).reduce((acc, [key, value]) => (value ? { ...acc, [key]: value } : acc), {}),
    page: Number(searchState.data.page),
  })

  const handleInputChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      const { value, name } = event.target
      searchState.setSearchState({ [name]: value, page: 1 }, false, true)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchState.setSearchState]
  )

  return (
    <DashboardPage>
      <Container>
        <Card>
          <VaccineRecordVerificationDatalist
            data={vaccinationForVerification?.getVaccinationForVerification?.vaccinations || []}
            pagination={vaccinationForVerification?.getVaccinationForVerification?.pagination}
            isLoading={isVaccinationLoading}
            tableHeader={
              <>
                <Datalist.Title>Vaccine Record Verification</Datalist.Title>
                <Box
                  display="grid"
                  gridGap="1rem"
                  gridTemplateColumns={
                    isMobile ? 'repeat(2, 1fr)' : 'repeat(auto-fit, minmax(13rem, max-content))'
                  }
                >
                  <TextInput
                    name="emailOrNameLike"
                    placeholder="Name or email"
                    value={searchState.data.emailOrNameLike || ''}
                    onChange={handleInputChange}
                    leftIcon={<Icon.Search />}
                    hasBottomContent={false}
                  />
                </Box>
              </>
            }
            requestDebounceInMs={250}
            onPageChange={(pageNumber) => {
              searchState.setSearchState({ page: pageNumber }, false)
            }}
            pageLength={
              vaccinationForVerification?.getVaccinationForVerification?.pagination.length
            }
          />
        </Card>
      </Container>
    </DashboardPage>
  )
}

export { VaccineRecordVerification }
